import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useTheme} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import {Box, Typography} from "@material-ui/core";
import {getDomain} from "../../api/BackendRestClient";


export const PublicTrackingHelpDialog: React.FC<{ open: boolean, setOpen: (boolean) => void }> = ({open, setOpen}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const {t} = useTranslation();
    const domain = getDomain();


    return (
        <Dialog
            maxWidth="lg"
            fullScreen={fullScreen}
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogContent>
                <Typography variant="body1">
                    {t("public-tracking.help.info")}
                    <Box fontWeight="fontWeightBold" component="span">
                        {t("public-tracking.help.info-90days")}
                    </Box>
                </Typography>

                <Typography variant="body1">
                    {t("public-tracking.help.info-sub")}
                    <Box fontWeight="fontWeightBold" component="span">
                        {t("public-tracking.help.info-sub-search")}
                    </Box>
                </Typography>

                <InfoList caption={"public-tracking.help.hawb.title"}
                          items={["public-tracking.help.hawb.info-1", "public-tracking.help.hawb.info-2", "public-tracking.help.hawb.info-3"]}/>

                <InfoList caption={"public-tracking.help.bl.title"}
                          items={["public-tracking.help.bl.info-1", "public-tracking.help.bl.info-2", "public-tracking.help.bl.info-3", "public-tracking.help.bl.info-4"]}/>

                <InfoList caption={"public-tracking.help.hwb.title"}
                          items={["public-tracking.help.hwb.info-1", "public-tracking.help.hwb.info-2", "public-tracking.help.hwb.info-3", "public-tracking.help.hwb.info-4"]}/>

                <InfoList caption={"public-tracking.help.fcl.title"}
                          items={["public-tracking.help.fcl.info-1", "public-tracking.help.fcl.info-2", "public-tracking.help.fcl.info-3"]}/>

                <InfoList caption={"public-tracking.help.spot.title"}
                          items={["public-tracking.help.spot.info-1", "public-tracking.help.spot.info-2"]}/>

                {domain === "VCP" && <InfoList caption={"public-tracking.help.parcel.title"}
                                               items={["public-tracking.help.parcel.info-1", "public-tracking.help.parcel.info-2"]}/>}

            </DialogContent>
            <DialogActions style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Button autoFocus onClick={() => setOpen(false)} color="primary" variant="contained">
                    {t("core.close")}
                </Button>
            </DialogActions>
        </Dialog>

    );
};

export const InfoList: React.FC<{ caption: string, items: string[] }> = ({caption, items}) => {
    const {t} = useTranslation();


    return (
        <Box component="div">
            <Typography variant="h6">{t(caption)}</Typography>
            <ul>
                {items.map(item => {
                    return (<li key={item}>
                        <Typography variant="body1">{t(item)}</Typography>
                    </li>)
                })}
            </ul>
        </Box>
    )
};

export default PublicTrackingHelpDialog;
